import React from 'react';
import PropTypes from 'prop-types';
import statisticsLayout from '../constants/statisticsLayout';

function StatisticsHeader({ translate }) {
  return (
    <div className='container-header'>
      <h3>{translate(statisticsLayout.sectionTitle)}</h3>
    </div>
  );
}

StatisticsHeader.propTypes = {
  translate: PropTypes.func.isRequired
};

export default StatisticsHeader;
